import { useCallback } from 'react';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

export const GetIsFullScreen = () => {
  const theme = useTheme();
  const isFullScreen = useMediaQuery(theme.breakpoints.down('md'));
  return useCallback(() => isFullScreen, [isFullScreen]);
};
